import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectStudentEventPayload } from 'src/app/models/event-payloads.model';
import { AnnouncementItemViewModel } from 'src/app/models/item.model';
import { AnnouncementPublisherComponent } from '../announcement-publisher/announcement-publisher.component';
import { AttachmentsComponent } from '../attachments/attachments.component';
import { HubItemMessageComponent } from '../hub-item-message/hub-item-message.component';
import { ListItemHeaderComponent } from '../list-item-header/list-item-header.component';

@Component({
  selector: 'app-announcement-item',
  templateUrl: './announcement-item.component.html',
  styleUrls: ['./announcement-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ListItemHeaderComponent,
    HubItemMessageComponent,
    AttachmentsComponent,
    AnnouncementPublisherComponent
  ]
})
export class AnnouncementItemComponent {
  @Input() item: AnnouncementItemViewModel;
  @Input() showPublisherLink: boolean;
  @Output() selectItem = new EventEmitter<string>();
  @Output() selectStudent = new EventEmitter<SelectStudentEventPayload>();
  @Output() openAttachment = new EventEmitter<string>();
  @Output() getThumb = new EventEmitter<string>();
}
